'use strict';

var $d = require('../dependency');
var _ = $d._;

exports.durationDiffEnabled = durationDiffEnabled;

function durationDiffEnabled(context, config, next) {
  var apiParsedResponseList = context.apiParsedResponseList,
    apiMergedResponse = {},
    parsedResponseArray,
    extensionObj;
  //!ToDo eliminate this forEach
  _.forEach(context.dataConfig, function (queryParams, index) {
    extensionObj = _.find(queryParams.extensions, function (extensionObj) {
      return extensionObj.name === 'durationDiffEnabled';
    });
    if (extensionObj) {

      _.forEach(extensionObj.params.fields, function (field) {
        if (field === 'timestamp') {
          parsedResponseArray = apiParsedResponseList[index][field];
          parsedResponseArray.shift();
        } else {
          parsedResponseArray = [];
          _.forEach(_.range(apiParsedResponseList[index][field].length - 1), function (indexVal) {
            parsedResponseArray.push(
              apiParsedResponseList[index][field][indexVal + 1] -
              apiParsedResponseList[index][field][indexVal]
            );
          });
        }
        apiMergedResponse[field] = parsedResponseArray;
      });

    }
  });

  context.apiMergedResponse = apiMergedResponse;
  next();
}